var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8216 25.3333H4.82161C4.46799 25.3333 4.12885 25.1928 3.87881 24.9428C3.62876 24.6927 3.48828 24.3536 3.48828 24C3.48828 23.6463 3.62876 23.3072 3.87881 23.0571C4.12885 22.8071 4.46799 22.6666 4.82161 22.6666H28.8216C29.1752 22.6666 29.5144 22.8071 29.7644 23.0571C30.0145 23.3072 30.1549 23.6463 30.1549 24C30.1549 24.3536 30.0145 24.6927 29.7644 24.9428C29.5144 25.1928 29.1752 25.3333 28.8216 25.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8216 17.3333H4.82161C4.46799 17.3333 4.12885 17.1928 3.87881 16.9428C3.62876 16.6927 3.48828 16.3536 3.48828 16C3.48828 15.6463 3.62876 15.3072 3.87881 15.0572C4.12885 14.8071 4.46799 14.6666 4.82161 14.6666H28.8216C29.1752 14.6666 29.5144 14.8071 29.7644 15.0572C30.0145 15.3072 30.1549 15.6463 30.1549 16C30.1549 16.3536 30.0145 16.6927 29.7644 16.9428C29.5144 17.1928 29.1752 17.3333 28.8216 17.3333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8216 9.33329H4.82161C4.46799 9.33329 4.12885 9.19282 3.87881 8.94277C3.62876 8.69272 3.48828 8.35358 3.48828 7.99996C3.48828 7.64634 3.62876 7.3072 3.87881 7.05715C4.12885 6.8071 4.46799 6.66663 4.82161 6.66663H28.8216C29.1752 6.66663 29.5144 6.8071 29.7644 7.05715C30.0145 7.3072 30.1549 7.64634 30.1549 7.99996C30.1549 8.35358 30.0145 8.69272 29.7644 8.94277C29.5144 9.19282 29.1752 9.33329 28.8216 9.33329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/alignCenter.22299d4ccf65b515a1ac331201375b0d.svg";
export { ForwardRef as ReactComponent };